import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createDomain } from "../../../../graphql/mutations";
import CardContainer from "../../../../components/Common/CardContainer";
import { Form, Alert } from "react-bootstrap";
import TextInput from "../../../../components/Common/TextInput";
import ButtonInput from "../../../../components/Common/ButtonInput";
import { toast } from "react-toastify";
import * as BootstrapVariants from "../../../../constants/Bootstrap/Variants";
import * as GlobalSubmitUIDelay from "../../../../constants/AppBehaviour/globalSubmitUIDelay";
import DomainValidation from "../DomainValidation";
import CollegeNONE from "../../../../graphql/Constants/Colleges/None";
// https://www.npmjs.com/package/is-valid-domain

const DomainCreate = (props) => {
  const [errors, setErrors] = useState({});
  const [generalError, setGeneralError] = useState("");
  const [name, setName] = useState("");
  const [formSubmitInProgress, setFormSubmitInProgress] = useState(false);
  const [createButtonDisableStatus, setCreateButtonDisableStatus] = useState(
    true
  );

  //#region  handle domain change including validation checks
  const handleDomainNameChange = (event) => {
    const _errors = {};
    let providedName = event.target.value;
    setName(providedName);
    // check the domain validation
    let validationResult = DomainValidation(providedName);
    // check the result
    if (!validationResult.result) {
      _errors.name = validationResult.message;
      setCreateButtonDisableStatus(true);
    } else {
      setCreateButtonDisableStatus(false);
    }
    setErrors(_errors);
  };
  //#endregion

  //#region checling form is valid
  const isFormValid = () => {
    const _errors = {};

    // domain name is already checked and status button is already disabled
    // double check here
    // check the domain validation
    let validationResult = DomainValidation(name);
    // check the result
    if (!validationResult.result) {
      _errors.name = validationResult.message;
      setCreateButtonDisableStatus(true);
    } else {
      setCreateButtonDisableStatus(false);
    }
    setErrors(_errors);

    // Forms will be valid if the _errors object does not have any properties
    return Object.keys(_errors).length === 0;
  };
  //#endregion

  //#region Handle form submit
  const handleFormSubmission = async (event) => {
    event.preventDefault();
    setErrors({});
    setFormSubmitInProgress(true);
    if (!isFormValid()) {
      setFormSubmitInProgress(false);
      return;
    }

    // create school at this point
    let result = await handleCreateDomain();
    if (result.result) {
      // go back to list
      setTimeout(function () {
        toast.success(result.message);
        if (props.match.params.collegeId) {
          props.history.push(
            `/schools/${props.match.params.schoolId}/colleges/details/${props.match.params.collegeId}/tab/Domains`
          );
        } else {
          props.history.push(
            `/schools/details/${props.match.params.schoolId}/tab/Domains`
          );
        }
      }, GlobalSubmitUIDelay.DefaultDelay);
    } else {
      toast.error(result.message);
      setFormSubmitInProgress(false);
    }
  };
  //#endregion

  //#region  create domain business logic
  const handleCreateDomain = async () => {
    try {
      // initial required domain creation data
      let input = {
        name: name,
        deletedAt: null,
      };

      // check if we are building the domain for college or for school
      if (props.match.params.collegeId) {
        // this if for school college
        input = {
          ...input,
          schoolId: props.match.params.schoolId,
          domainCollegeId: props.match.params.collegeId,
        };
      } else {
        // this if for school
        // and we need to define the none college for collegeID
        input = {
          ...input,
          schoolId: props.match.params.schoolId,
          domainCollegeId: CollegeNONE.id,
        };
      }

      await API.graphql(graphqlOperation(createDomain, { input }));
      return { result: true, message: `Domain created successfully` };
    } catch (error) {
      return {
        result: false,
        message: `Error creating domain, ${JSON.stringify(error, null, 2)}`,
      };
    }
  };
  //#endregion

  //#region handle return
  const handleReturn = () => {
    // since we can create a domain for college as well we need to check how we got here and go back there
    if (props.match.params.collegeId) {
      props.history.push(
        `/schools/${props.match.params.schoolId}/colleges/details/${props.match.params.collegeId}/tab/Domains`
      );
    } else {
      props.history.push(
        `/schools/details/${props.match.params.schoolId}/tab/Domains`
      );
    }
  };
  //#endregion

  return (
    <Form onSubmit={handleFormSubmission} noValidate>
      <CardContainer
        header="Create a Domain"
        submitButton={
          <ButtonInput
            label="Create"
            disabled={createButtonDisableStatus}
            variant={BootstrapVariants.Success}
            formSubmitInProgress={formSubmitInProgress}
            formSubmittingText={"In Progress..."}
          />
        }
        backButton={
          <ButtonInput
            label="back"
            type="button"
            variant={BootstrapVariants.OutlineSecondary}
            onClick={() => handleReturn()}
          />
        }
      >
        {generalError && (
          <Alert variant={BootstrapVariants.Danger}>{generalError}</Alert>
        )}

        <TextInput
          type="name"
          id="name"
          label="Domain Name"
          placeholder="Enter a domain"
          value={name}
          onChange={(e) => handleDomainNameChange(e)}
          isRequired={true}
          error={errors.name}
        />
      </CardContainer>
    </Form>
  );
};

export default DomainCreate;
